module.exports = __webpack_public_path__ + "img/space4.af0c38aa.jpg";